const CARGOS = (state, cargos) => {
    state.cargos = cargos;
};


const TIPOCARGO = (state, tipocargo) => {
    state.tipocargo = tipocargo;
};

const SERIES = (state, series) => {
    state.series = series;
};

const CAJA = (state, caja) => {
    state.caja = caja;
};

export default {
    CARGOS,
    TIPOCARGO,
    SERIES,
    CAJA,
};